import { schemaTypes } from "../../../constants/constants";

const schema = {
  key: "energy_consume_report",
  name: "Energy Consumption Report",
  toolbar: [],
  content: [
    {
      key: "energy_consume_report",
      name: "Energy Consumption Report",
      type: schemaTypes.ENERGY_CONSUME_REPORT,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
    },
  ],
};

export default schema;
